// prompts.<area>.<key>: the suggested questions (services/platform-agent/platformAgentSuggestions.js), sent as typed.
// {{dish}} is a dish on the restaurant's menu, {{amount}} an amount in its currency (both from the picker).
export default {
  title: 'Hi {{first_name}}, what do you need for {{restaurant}}?',
  title_no_name: 'Hi, what do you need for {{restaurant}}?',
  text: 'I can answer questions about {{restaurant}} and make changes for you. Nothing changes until you approve it.',
  suggestions: 'Suggestions',
  // No restaurant selected (D18): Amigo asks which restaurant; the prompts let it ask for the restaurant's name.
  no_restaurant: {
    title: 'Hi {{first_name}}, which restaurant is it for?',
    title_no_name: 'Hi, which restaurant is it for?',
    text: "Name the restaurant in your message and I'll work on it, without opening it first. Nothing changes until you approve it.",
    prompts: {
      sunday_hours: "Change a restaurant's Sunday hours to 12:00–21:00",
      close_several: 'Close several restaurants on 24 December',
    },
  },
  prompts: {
    reports: {
      top_dishes: 'What were the top 10 dishes last month?',
      sales_vs_last_month: 'How did sales compare to last month?',
    },
    menu: {
      raise_dish_price: 'Raise the price of {{dish}} by {{amount}}',
      dish_sold_out: 'Mark {{dish}} sold out',
      dishes_without_photo: 'Which dishes have no photo?',
    },
    hours: {
      holiday_hours: 'Change our opening hours for 24 December',
    },
    order_settings: {
      minimum_order: 'Raise the minimum order to {{amount}}',
    },
    marketing: {
      promo_code: 'Create a 10 % promo code for this weekend',
    },
    my_info: {
      phone_number: 'Update our phone number',
    },
  },
};
